<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/insbillpay/getlist"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="detail(row)"
            >详情</el-button
          >
          <el-button type="text" size="mini" @click="audit(row)"
            >人工收费</el-button
          >
		  <el-button type="text" size="mini" v-if="row.payCodeStatus == 0" @click="getQrCodeBefor(row)"
		    >查看支付二维码</el-button
		  >
		  <el-button type="text" size="mini" v-if="row.payCodeStatus == 1" @click="offQrCode(row)"
		    >注销付二维码</el-button
		  >
        </template>
      </BaseTable>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="50%"
        @close="dialogClosed"
      >
        <BaseForm
          ref="baseForm"
          v-model="formData"
          :formOptions="cashFormOption"
          :rules="rules"
          labelWidth="120px"
          @formChange="formChange"
        >
          <el-form-item
            v-if="findItem('拉卡拉')"
            prop="lakala_amount"
            label="拉卡拉(元)"
          >
            <el-input
              v-model="formData.lakala_amount"
              @change="formChange"
              placeholder="元"
            ></el-input>
          </el-form-item>
		  
		  <el-form-item
		    v-if="findItem('企业微信')"
		    prop="qywx_amount"
		    label="企业微信(元)"
		  >
		    <el-input
		      v-model="formData.qywx_amount"
		      @change="formChange"
		      placeholder="元"
		    ></el-input>
		  </el-form-item>
		  
		  <el-form-item
		    v-if="findItem('微信收款码')"
		    prop="wx_qrcode_amount"
		    label="微信收款码(元)"
		  >
		    <el-input
		      v-model="formData.wx_qrcode_amount"
		      @change="formChange"
		      placeholder="元"
		    ></el-input>
		  </el-form-item>
          <el-form-item
            v-if="findItem('公户收款码')"
            prop="gh_qrcode_amount"
            label="公户收款码(元)"
          >
            <el-input
              v-model="formData.gh_qrcode_amount"
              placeholder="元"
              @change="formChange"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="findItem('公户')"
            prop="gh_amount"
            label="公户(元)"
          >
            <el-input
              v-model="formData.gh_amount"
              placeholder="元"
              @change="formChange"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="findItem('其他')" label="其他(元)">
            <el-input
              v-model="formData.other_amount"
              prop="other_amount"
              placeholder="元"
              @change="formChange"
            ></el-input>
          </el-form-item>
          <el-form-item label="实收金额(元)">
            <el-input
              v-model="formData.realInFee"
              disabled
              placeholder="元"
            ></el-input>
          </el-form-item>
          <el-form-item label="交费时间" prop="payTime">
            <el-date-picker
              type="datetime"
              v-model="formData.payTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="统筹公司" prop="plan_template">
            <el-select
              v-model="formData.plan_template"
            >
              <el-option label="河北统筹公司" :value="1"></el-option>
              <el-option label="辽宁统筹公司" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
        </BaseForm>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="handleSubmit"
            >确 定</el-button
          >
        </span>
      </el-dialog>
	  <!-- 支付二维码 -->
	  <el-dialog
	    title="支付二维码"
	    :visible.sync="payCodeVisibleBefor"
	    width="40%"
	    @close="payCodeVisibleBefor = false"
	  >
	    <el-form
	      :model="payData"
	      inline
	      ref="pay_data"
	      label-width="150px"
	      class="demo-ruleForm"
	    >
	  			<el-form-item class="from-item--30" label="支付渠道" prop="payChannel">
	  			  <el-select
	  			    v-model="payData.payChannel"
					placeholder="请选择支付渠道"
	  			    filterable
	  			  >
	  			    <el-option
	  			      v-for="item in payChannel"
	  			      :key="item.id"
	  			      :label="item.value"
	  			      :value="item.value"
	  			    ></el-option>
	  			  </el-select>
	  			</el-form-item>
	  			<el-form-item
	  			  class="from-item--30"
	  			  label="支付金额"
	  			  prop="payMoney"
	  			>
	  			  <el-input
	  				v-model="payData.payMoney"
	  				placeholder="支付金额"
	  			  />
	  			</el-form-item>
				<br>
				<el-form-item
				  class="from-item--30"
				  label="净费金额"
				  prop="consumeMoney"
				>
				  <el-input
					v-model="payData.consumeMoney"
					placeholder="净费金额"
				  />
				</el-form-item>
	  			<br>
	  			<div style="margin-left:50px;">
	  				<el-button size="mini" @click="payCodeVisibleBefor = false">取消</el-button>
	  				<el-button size="mini" @click="getQrCode">确定</el-button>
	  			</div>
	  		</el-form>
	  </el-dialog>
	  
	  <el-dialog
	    title="支付二维码"
	    :visible.sync="payCodeVisible"
	    width="40%"
	    @close="payCodeVisible = false"
	  >
	    <div class="row-left">
	  			<div>车 牌 号: &nbsp{{ payCodeData.carNo }}</div>
	  			<div>车 架 号: &nbsp{{ payCodeData.vin }}</div>
	  			<div>被服务人: &nbsp{{ payCodeData.personName }}</div>
	  			<div>流 水 号: &nbsp{{ payCodeData.insBillId }}</div>
	  			<div>起止日期: &nbsp{{ payCodeData.beginTime }}至{{ payCodeData.endTime }}</div>
	  			<div style="height: 40px;">服务明细: &nbsp<b>{{ payCodeData.detail }}</b></div>
	  			<!-- <div>支付渠道: &nbsp{{ payData.payChannel }}</div> -->
	  			<div>应交金额: &nbsp<span style="color:red">{{ payCodeData.payMoney }}元</span></div>
				<div>净费金额: &nbsp<span style="color:red">{{ payCodeData.consumeMoney }}元</span></div>
	  		</div>
	  		<div class="row-right">
	  			<img :src="payCodeData.qrCode" alt="" class="qr-code">
	  			<br>
          <div>请使用微信或支付宝</div>
          <div class="pay-tips">支付宝限时立减！最高可达200元！</div>
	  			<!-- <img src="../../../assets/img/wxpay.png" class="wxpay-img" />
	  			<img src="../../../assets/img/zfbpay.png" class="zfbpay-img" /> -->
	  		</div>
	  		<div style="clear: both;"></div>
	  </el-dialog>
	  
    </div>
  </div>
</template>

<script>
import { searchFormOption, cashFormOption } from "./formOptions";
import { columns } from "./columns";
import { rules } from "./rules";

export default {
  name: "Pay",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
      orgOption: [],
      // 弹框相关
      dialogTitle: "",
      dialogVisible: false,
      // 表单相关
      formData: {
        inType: [],
		lakala_amount: 0,
		qywx_amount: 0,
        wx_qrcode_amount: 0,
        gh_qrcode_amount: 0,
        gh_amount: 0,
        other_amount: 0,
      },
      rules: rules(this),
	  payCodeVisible: false,
	  payCodeVisibleBefor: false,
	  payCodeData: {},
	  payCodeStatus: false,
	  payData: {
		  payChannel: '',
		  payMoney: 0,
		  consumeMoney: 0
	  },
	  insBillId: 0,
	  payChannel: [],
    };
  },
  computed: {
    columns,
    searchFormOption,
    cashFormOption,
  },
  created() {
	  this.getPayChannel();
    //console.log(this.columns);
  },
  methods: {
    audit(row) {
      this.dialogTitle = `统筹单审核(${row.insBillId})`;
      this.dialogVisible = true;
      this.formData = {
        ...this.formData,
        ...row,
        is_pass: 1,
        payTime: this.$moment().format(),
      };
    },
	// 获取支付方式
    getPayChannel() {
      this.$api.post("/admin/insbillpay/getPayType", {}).then((res) => {
      	if(res.data){
      		this.payChannel = res.data;
      	}
      });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      return {
        ...params,
        ...this.searchData,
      };
    },
    // 点击详情
    detail(row) {
      this.$router.push({
        path: "/issue/detail",
        query: {
          insBillId: row.insBillId,
        },
      });
    },
    findItem(key) {
      return this.formData.inType?.find((item) => item === key);
    },
    formChange(val, prop) {
      console.log(val);
      if (prop === "inType") {
		if (!this.findItem("拉卡拉")) {
		  this.formData = {
		    ...this.formData,
		    lakala_amount: 0,
		  };
		}
		if (!this.findItem("企业微信")) {
		  this.formData = {
		    ...this.formData,
		    qywx_amount: 0,
		  };
		}
        if (!this.findItem("微信收款码")) {
          this.formData = {
            ...this.formData,
            wx_qrcode_amount: 0,
          };
        }
        if (!this.findItem("公户收款码")) {
          this.formData = {
            ...this.formData,
            gh_qrcode_amount: 0,
          };
        }
        if (!this.findItem("公户")) {
          this.formData = {
            ...this.formData,
            gh_amount: 0,
          };
        }
        if (!this.findItem("其他")) {
          this.formData = {
            ...this.formData,
            other_amount: 0,
          };
        }
      }
      this.formData = {
        ...this.formData,
        realInFee:
		  this.formData.lakala_amount * 1 +
		  this.formData.qywx_amount * 1 +
          this.formData.wx_qrcode_amount * 1 +
          this.formData.gh_qrcode_amount * 1 +
          this.formData.gh_amount * 1 +
          this.formData.other_amount * 1,
      };
    },
    // 提交
    handleSubmit() {
      console.log(this.formData);
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          console.log(this.formData);
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              await this.$api.post(
                "/admin/insbillpay/submit",
                { ...this.formData, inType: this.formData.inType.join(",") },
                "交费"
              );
              this.dialogVisible = false;
              this.handleSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },
    // 弹框关闭
    dialogClosed() {
      this.formData = {
        inType: [],
		lakala_amount: 0,
		qywx_amount: 0,
        wx_qrcode_amount: 0,
        gh_qrcode_amount: 0,
        gh_amount: 0,
        other_amount: 0,
      };
      this.$refs.baseForm.resetFields();
    },
	// 查看支付二维码
	async getQrCodeBefor(row) {
		this.payCodeVisibleBefor = true;
		this.insBillId = row.insBillId;
		this.payData.payMoney = row.customerFee || 0;
	},
	async getQrCode() {
		this.payCodeVisibleBefor = false;
		this.payCodeVisible = true;
		let money = 0;
		if(this.payData.consumeMoney > 0){
			money = this.payData.consumeMoney;
		}else{
			money = this.payData.payMoney;
		}
		const res = await this.$api.post("/admin/insBillCheck/getPayQrCode", {
		  insBillId: this.insBillId,
		  payChannel: this.payData.payChannel,
		  payMoney: money
		});
		this.payCodeData = {...res.data}
		this.payCodeData.payMoney = this.payData.payMoney || 0;
		this.payCodeData.consumeMoney = this.payData.consumeMoney || 0;
		this.handleSearch();
	},
	// 注销二维码
	offQrCode(row) {
		this.$api.post("/admin/insBillCheck/offPayQrCode", {
		  insBillId: row.insBillId,
		}).then((res) => {
			this.handleSearch();
			this.$message({
			  type: "info",
			  message: "注销成功",
			});
	
		});	
	},
  },
};
</script>
<style scoped lang="scss">
	.row-left {
		float:left;
		width:60%;
		fonst-size:16px;
		color: black;
		div {
			height:33px;
		}
	}
	.row-right {
		float:left;
		width:40%;
		text-align: center;
	}
  .pay-tips {
    margin-top: 10px;
    color: red;
  }
	.qr-code {
		width: 180px;
		height: 180px;
	}
	.wxpay-img {
		width: 30px;
		height: 30px;
		// margin-right: 30px;
		margin-top: 10px;
	}
	.zfbpay-img {
		width: 30px;
		height: 30px;
		margin-top: 10px;
	}
</style>